import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'gicleesizes',
  component: lazyLoad('Admin/Data/GicleeSizes'),
}
